/**
 * Phase 50 Plan 09 — TanStack Query hook for /api/manager/sla-breach-dashboard.
 *
 * Query key `['sla-breach-dashboard', { from, to }]` allows targeted
 * invalidation from any mutation that might change task SLA state.
 *
 * `staleTime: 30_000` matches MyTasks staleness — the breach dashboard is a
 * read-only runtime snapshot; 30s ensures a manager refreshing quickly does
 * not hammer the DB on every focus change.
 */
import { useQuery } from '@tanstack/react-query';
import {
  fetchSlaBreachDashboard,
  type SlaBreachResult,
} from '../services/api/slaBreachDashboard';

export interface UseSlaBreachDashboardOptions {
  from: string;
  to: string;
  enabled?: boolean;
}

export function useSlaBreachDashboard(opts: UseSlaBreachDashboardOptions) {
  return useQuery<SlaBreachResult>({
    queryKey: ['sla-breach-dashboard', { from: opts.from, to: opts.to }],
    queryFn: () => fetchSlaBreachDashboard({ from: opts.from, to: opts.to }),
    enabled: (opts.enabled ?? true) && Boolean(opts.from && opts.to),
    staleTime: 30_000,
  });
}
